import Constants from '../enums/Constants';
import { SET_CURRENT_MEDIA_ACTION } from '../store/store-types';

export default {
  methods: {
    /**
     * Makes `media` the current selection and loads its full-size image.
     *
     * The selection is published straight away so the title, buttons and
     * description can render while the picture is still downloading - those run
     * a few hundred KB and can take several seconds from S3. The returned
     * promise still waits for the image, so callers that need to draw it keep
     * working as before.
     */
    getMediaImageAndSetCurrentMedia(media) {
      return new Promise((resolve) => {
        this.$store.dispatch(SET_CURRENT_MEDIA_ACTION, media);
        if (media.type != 'static' || media.img) {
          resolve();
          return;
        }
        let img = new Image();
        img.crossOrigin = "Anonymous";
        let src = `${Constants.S3_BUCKET_URL}media/content/${media.mediaName}${Constants.IMG_EXT_JPG}`;
        img.onload = () => {
          media.img = img;
          this.$store.dispatch(SET_CURRENT_MEDIA_ACTION, media);
          resolve();
        };
        // Without this a broken image would leave the promise pending forever.
        img.onerror = () => {
          resolve();
        };
        img.src = src;
      });
    }
  },
};
